module.exports = __webpack_public_path__ + "img/1585892677.fc57ebab.jpg";